export default __webpack_public_path__ + "static/media/featured-item-16.af3abd8f.png";